import { typedRouting } from './../typedRouting'

export const getFlowUrlByPath = (flowPath: string) => {
  const pathSegments = flowPath.split('/').filter((pathSegment) => pathSegment.length > 0)

  return typedRouting.linkBuilder.cmsFiles({ fso_path: pathSegments.join('--') })
}
